var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vc-badge",class:_vm.typeClasses},[(_vm.showInfo)?_c('span',[_vm._v(_vm._s(_vm.countText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }